<div class="container-fluid vh-100">
  <div class="row h-100">
    <!-- Left Side -->
    <div class="col-md-6 d-flex flex-column justify-content-start align-items-start p-4 bg-light">
      <img src="assets/pptgenlogo.png" alt="Logo" style="width: 300px; height: 100px;" />

      <div class="mt-5 w-100" style="max-width: 400px;">
        <h4 class="mb-4">Login</h4>
        <form (ngSubmit)="login()">
          <div class="mb-3">
            <label for="loginid" class="form-label">Login ID</label>
            <input type="text" id="loginid" class="form-control" required [(ngModel)]="loginid" name="loginid" />
          </div>

          <div class="mb-3">
            <label for="password" class="form-label">Password</label>
            <input type="password" id="password" class="form-control" required [(ngModel)]="password" name="password" />
          </div>

          <div class="mb-3 text-danger" *ngIf="error">{{ error }}</div>

          <button type="submit" class="btn text-white w-100" style="background-color: #616672;">
            Submit
          </button>
        </form>
      </div>
    </div>
    <!-- Right Side -->
    <div class="col-12 col-md-6 d-flex justify-content-start align-items-center gradient-bg text-white p-4">
      <div class="text-start me-md-5 me-3">
        <h1 class="display-6 fw-bold">Welcome !</h1>
        <p class="lead mt-3"> Streamline your slide creation process.<br />
          This software is for exclusive use by Enhance & Excel.<br />
          <br />
          Based on your role you can Manage users, design templates, and generate stunning presentations with
          ease.<br />
          <br /> Every new assignement will be considered as new project. Each project uses a template and user inputs
          in the
          form of a slides.<br />
          After you finalize input, create the bridge file.<br />
          <br />
          In the pptGen add-in component in MS-Powerpoint - import this bridge file - check it and then save as pdf /
          html or import it in storyline 3.0 or active presneter. <br />
        </p>
      </div>
    </div>
  </div>
</div>